var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NodeViewWrapper',{staticClass:"mention",attrs:{"as":"span","contenteditable":"false"}},[_c('NcUserBubble',{staticClass:"mention-user-bubble",attrs:{"user":_vm.node.attrs.id,"display-name":_vm.username,"primary":_vm.isCurrentUser}},[_vm._v("\n\t\t@"+_vm._s(_vm.username)+"\n\t")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }